import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function RateSensitiveSectors({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data?.rising || !data?.falling) return null;

    const sectors = [...new Set([...Object.keys(data.rising), ...Object.keys(data.falling)])]
        .filter(s => s !== 'Unknown');
    if (sectors.length === 0) return null;

    const chartData = sectors.map(s => ({
        sector: s,
        sectorShort: s.length > 15 ? s.slice(0, 15) + '…' : s,
        'Rate Rising': data.rising[s] || 0,
        'Rate Falling': data.falling[s] || 0,
    }));

    return (
        <ChartSection
            id="rate-sectors"
            title="Which sectors does Congress trade when rates change?"
            subtitle="Sector distribution during periods of rising vs falling mortgage rates (>0.3% quarterly change)"
        >
            <Box sx={{ height: 380 }}>
                <ResponsiveBar
                    data={chartData}
                    keys={['Rate Rising', 'Rate Falling']}
                    indexBy="sector"
                    margin={{ top: 20, right: 140, bottom: 80, left: 60 }}
                    padding={0.3}
                    groupMode="grouped"
                    colors={[colors.error, colors.success]}
                    borderRadius={3}
                    enableLabel={false}
                    axisBottom={{
                        tickRotation: -30,
                        format: v => {
                            const row = chartData.find(r => r.sector === v);
                            return row ? row.sectorShort : v;
                        },
                    }}
                    axisLeft={{ legend: 'Trades', legendPosition: 'middle', legendOffset: -50 }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'top-right',
                            direction: 'column',
                            translateX: 120,
                            itemWidth: 100,
                            itemHeight: 20,
                            symbolSize: 10,
                            itemTextColor: '#9ca3af',
                        },
                    ]}
                    tooltip={({ id, value, data: d, color }) => (
                        <ChartTooltip
                            title={d.sector}
                            rows={[{ label: id, value: value.toLocaleString() + ' trades', color }]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
